/* Soccer Belief: repair legacy internal destinations. */
(() => {
  'use strict';

  const canonicalUrl = (raw) => {
    let url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (_) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;

    const originalPath = url.pathname;
    const lowerPath = originalPath.toLowerCase().replace(/\/$/, '');
    const localizedPage = lowerPath.match(/^\/(de|fr)\/(story|contact)$/);
    if (localizedPage) {
      url.pathname = `/${localizedPage[1]}/pages/${localizedPage[2]}`;
    } else if (lowerPath === '/story' || lowerPath === '/contact') {
      url.pathname = `/pages${lowerPath}`;
    }

    return url.pathname === originalPath ? null : url;
  };

  const current = canonicalUrl(window.location.href);
  if (current) {
    window.location.replace(current.href);
    return;
  }

  const repairLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const canonical = canonicalUrl(link.href);
      if (canonical) link.href = canonical.href;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => repairLinks(), { once: true });
  } else {
    repairLinks();
  }
})();
